

const APP_VERSION = '1.3.9';
export default APP_VERSION
